export default __webpack_public_path__ + "static/media/People_13.39553ae5.png";